module.exports = __webpack_public_path__ + "static/media/Flaticon.9b347ee5.woff";